import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { AppLabel } from "../../../../shared/components/AppLabel";

export const NoChatsLabel = () => {
  const { t } = useTranslation();
  return (
    <AppLabel className={styles["no-chats-label"]}>
      {t("chatbot.table_no_chats")}
    </AppLabel>
  );
};
